import { useContext, useState } from "react";

import { OnPremOrderListingContext } from "../context/OnPremOrderListingContext";
import { OnPremOrderListingFilters } from "./useOnPremOrderListingFilters";

export const useOnPremOrderListing = () => {
    const { items, totalItems, selectedItems, setSelectedItems, reloadData } = useContext(OnPremOrderListingContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getData = async (filters: OnPremOrderListingFilters): Promise<void> => {
        setIsLoading(true);

        await reloadData(filters);

        setIsLoading(false);
    };

    return {
        items,
        totalItems,
        isLoading,
        getData,
        setSelectedItems,
        selectedItems
    };
};
